// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"4af4e47d","142":"b1c69545","260":"f97a390a","657":"4acb3d8c","875":"21fac8c1"}[chunkId] + ".chunk.css";
};